import React, { useState } from 'react';
import { Button } from '../../../components/ui';
import ListWebhooks from './ListWebhooks';

export default function EditWebhookButton({ template, onEdit }) {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Button
        className="templates__edit-btn"
        id={`webhook-${template.id}`}
        type="button"
        onClick={() => setShowModal(true)}
      >
        Webhooks
      </Button>
      <ListWebhooks
        isVisible={showModal}
        template={template}
        onHide={() => setShowModal(false)}
        onSaveTemplate={onEdit}
      />
    </>
  );
}
